var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "navigation-entry",
      class: [_vm.bemFacets, _vm.rootClasses]
    },
    [
      _c(
        "a",
        {
          staticClass: "u-reset navigation-entry--label",
          class: _vm.labelActiveClass,
          attrs: { href: _vm.path }
        },
        [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.items, function(item, idx) {
        return _c(
          "navigation-entry",
          _vm._b(
            {
              key: idx,
              staticClass: "navigation-entry--child",
              attrs: { "is-child": true, facets: _vm.facets }
            },
            "navigation-entry",
            item,
            false
          )
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3329c75e", { render: render, staticRenderFns: staticRenderFns })
  }
}